<div [formGroup]="form" class="py-2 px-6">
  <div class="flex justify-between gap-4 items-center">
    <mat-form-field
      class="input-tg mt-message-input w-3/12"
      appearance="outline"
    >
      <mat-label>Código Bancário</mat-label>
      <input matInput formControlName="code_bank" />
    </mat-form-field>

    <mat-form-field
      class="input-tg mt-message-input w-3/12"
      appearance="outline"
    >
      <mat-label>Nome</mat-label>
      <input matInput formControlName="name" />
    </mat-form-field>

    <mat-slide-toggle class="w-4/12" formControlName="active">{{
      form.get('active')?.value ? 'Ativo' : 'Inativo'
    }}</mat-slide-toggle>
    <button
      mat-flat-button
      class="btn-tg w-2/12"
      [disabled]="form.invalid || loading"
      (click)="createItem()"
    >
      @if (loading) {
        <mat-spinner
          diameter="22"
          class="loading-spinner"
          selected-track-color="red"
        ></mat-spinner>
      } @else {
        Adicionar Novo
      }
    </button>
  </div>
  <!--  <button mat-flat-button class="btn-tg w-full mt-6" [disabled]="!checkForm()" (click)="sendLogin()">entrar</button>-->
</div>
